import React, { useMemo } from "react";
import { Button, Icon } from "antd";
import Spacer from "../Spacer";
import styles from "./index.module.scss";
import { SourceItem } from "../../../../pages/ResourcePool/service";
import { CourseWareTypeList } from "../../../../utils/common";

interface FooterProps {
    onShowAside?: () => void;
    listLength: number;
    data: SourceItem;
    activeIndex: number;
    setActiveIndex: (index: number) => void;
}

export default function StuFooter({
    data,
    listLength,
    activeIndex,
    setActiveIndex
}: FooterProps) {
    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    data?.sourceFileEntity?.fileType?.toLowerCase()
                )
            ) {
                return type;
            }
        }
        return "";
    }, [data]);

    return (
        <div className={styles.root}>
            {activeIndex > 0 && (
                <Button
                    className={styles.btnPrev}
                    onClick={() => {
                        setActiveIndex(activeIndex - 1);
                    }}>
                    <Icon type="caret-left" /> 上一个
                </Button>
            )}
            <Button className={styles.btnDownload}>
                <Icon type="question-circle" />
                我的问题
            </Button>
            {!["href", "polyv", "video"].includes(fileType) &&
                data?.isDownload === 1 && (
                    <Button
                        type="link"
                        target="_blank"
                        href={`${
                            data?.sourceFileEntity?.viewUrl
                        }?attname=${encodeURIComponent(
                            data?.sourceFileEntity?.fileName
                        )}`}
                        className={styles.btnDownload}>
                        <Icon type="download" />
                        下载课件
                    </Button>
                )}
            <Spacer />
            {activeIndex < listLength - 1 && (
                <Button
                    className={styles.btnNext}
                    onClick={() => {
                        setActiveIndex(activeIndex + 1);
                    }}>
                    下一个 <Icon type="caret-right" />
                </Button>
            )}
        </div>
    );
}
